export default __webpack_public_path__ + "static/media/logo.d382a79f.webp";